import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GdprAutoDeleteEffects } from './gdpr-auto-delete.effects';
import { GdprAutoDeleteNamespace, GdprAutoDeleteReducer } from './gdpr-auto-delete.store';

@NgModule({
  imports: [
    StoreModule.forFeature(GdprAutoDeleteNamespace, GdprAutoDeleteReducer),
    EffectsModule.forFeature([GdprAutoDeleteEffects]),
  ],
})
export class GdprAutoDeleteDataModule {}
